<template lang="pug">
  .history-code
    .form-section
      .history-container
        .history-label(:class="color") Version
        div {{ dataOriginal.version }}
      .history-container
        .history-label(:class="color") {{ capitalize(dataOriginal.transaction) }}d by
        shNameUser(v-if="dataOriginal.transaction === 'create'" :dni="dataOriginal.createdBy")
        shNameUser(v-else :dni="dataOriginal.updatedBy")
      .history-container(v-if="dataOriginal.type")
        .history-label Type
        div {{ capitalize(dataOriginal.type) }}
      .history-container(v-if="dataOriginal.value")
        .history-label Value
        div {{ money(dataOriginal.value) }}
      .history-container(v-if="dataOriginal.percent")
        .history-label Percent
        div {{ percent(dataOriginal.percent) }}
      .history-container(v-if="dataOriginal.active || dataOriginal.active === false")
        .history-label Active
        div {{ dataOriginal.active }}
</template>

<script>
import mFilters from '@/mixins/filters'
import shNameUser from '@/components/elements/NameUser'

export default {
  name: 'HistoryCode',

  mixins: [mFilters],

  components: { shNameUser },

  props: {
    dataOriginal: Object,
    color: String
  }
}
</script>

<style lang="stylus">
.history-code
  position relative
  margin 1.4em 0 1.8em 0
</style>



// WEBPACK FOOTER //
// src/components/pages/code/History.vue